@let table = this.table();
@let withCallWaiterMain = this.withCallWaiterLaneAssistance();
@let withCallWaiterRequestBill = this.withCallWaiterRequestBill();

<app-page-header
  class="header"
  [tableName]="table?.tableName"
  [backSwipe]="backSwipeConfig"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <div class="title">
    <img
      class="logo"
      height="220"
      width="222"
      src="/images/logo.webp"
      alt="Georgian Bowl logo"
    >
    <span class="text">Service Centre</span>
    <span class="description">Want to place an order? Ready for your bill? Tangled pins?</span>
    <span class="green">Tap for quick assistance.</span>
  </div>


  <div class="call__buttons">

    @if (withCallWaiterRequestBill) {
      <app-button-call-waiter-bill
        class="call-waiter"
        coreActivitySection="RequestAServer"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('secondary', collWaiterRequestBill())"
      />
    }

    @if (withCallWaiterMain) {
      <app-button-call-waiter-main
        class="call-waiter"
        coreActivitySection="LaneAssistance"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('main', callWaiterLaneAssistance())"
      />
    }

  </div>

  <app-service-center-amenities class="amenities"/>
</div>

